export const lastAction = (state = null, action) => {
  return action;
};



// WEBPACK FOOTER //
// ./src/redux/reducers/lastAction.js